import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SearchDeliveryEntity } from '../../domain/entities/SearchDeliveryEntity'
import type { SearchAdminDto } from '@/backend/market'

export class SearchDeliveryModel extends SearchDeliveryEntity {
  constructor(dataDto: SearchAdminDto) {
    super()
    mapEntityProperties<SearchDeliveryEntity>(this, dataDto)
  }
}
